import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../Component/Login/Login";
import Dashboard from "../Component/Dashboard/Dashboard";
import Orders from "../Component/Orders/Orders";
import { GetToken } from "../Component/utils";

function AppRoutes() {
  function RequireAuth({ children }) {
    const token = GetToken();
    return token ? children : <Navigate to="/login" replace />;
  }
  function AlreadyLogin({ children }) {
    const token = GetToken();
    return token ? <Navigate to="/dashboard" replace /> : children;
  }
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <AlreadyLogin>
            <Login />
          </AlreadyLogin>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/orders"
        element={
          <RequireAuth>
            <Orders />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default AppRoutes;